import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { DataService } from './data.service';
import { HttpResponseHandler } from './http-response-handler.service';
import { HttpResponseInterceptor } from './http.interceptor';
import { AuthTokenService } from './auth-token.service';

@NgModule({
  imports: [CommonModule, HttpClientModule]
})
export class HttpServiceModule {
  static forRoot(): ModuleWithProviders<HttpServiceModule> {
    return {
      ngModule: HttpServiceModule,
      providers: [
        DataService,
        HttpResponseHandler,
        {
          provide:HTTP_INTERCEPTORS,
          useClass:AuthTokenService,
          multi:true
        }
      ]
    };
  }
}
